// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_4JD","cls2":"AutoCompleteResultRow-cls2_urf AutoCompleteResultRow-cls1_4JD"};